import type { CommonAction } from "@iflyrpa/share";
import { ActiomCommonParams, ActionCommonParamsSchema } from "../../types";
import { executeAction, formatSectionHtml } from "../../utils";
import { mockAction } from "./mock";
import { rpaAction } from "./rpa";

type CoverType = "single" | "multiple" | "no";

import { z } from "zod";

export const ToutiaoPublishParamsSchema = ActionCommonParamsSchema.extend({
    saveType: z.union([z.literal("draft"), z.literal("publish")]), // 保存成草稿 / 发布
    title: z.string(),
    content: z.string(),
    proxyLoc: z.string().optional(), // 代理位置
    localIP: z.string().optional(), // 用户ip
    huiwenToken: z.string().optional(), // 绘文token
    settingInfo: z.object({
        toutiaoCoverType: z.union([z.literal("single"), z.literal("multiple"), z.literal("no")]),
        toutiaoTitleType: z.union([z.literal("single"), z.literal("multiple")]), // 已关闭对应功能，保留参数，兼容老版本
        toutiaoSingleCover: z.string(),
        toutiaoMultCover: z.array(z.string()),
        toutiaoAd: z.string(), // 广告配置 - 投放广告/不投放广告
        toutiaoOriginal: z.string().optional(), // 原创声明-已修改为首发声明，兼容老用户
        toutiaoExclusive: z.number().optional(), // 头条首发  0 - 声明非首发 1- 声明首发
        toutiaoCollectionId: z.string().optional(), // 头条合集id
        toutiaoTransWtt: z.boolean().optional(), // 是否同步微头条
        toutiaoClaim: z
            .object({
                type: z.number(), // 作品声明
                source_author_uid: z.string().optional(),
                source_author_name: z.string().optional(),
                time_format: z.string().optional(),
                position: z
                    .object({
                        position: z.string(),
                        city: z.string(),
                        longitude: z.number(),
                        latitude: z.number(),
                        type_code: z.string(),
                        poi_id: z.string(),
                    })
                    .optional(),
            })
            .optional(),
        toutiaoLocation: z
            .object({
                label: z.string(),
                value: z.string(),
            })
            .passthrough()
            .optional(), // 位置
        toutiaoTopic: z.array(z.object({ id: z.string(), word: z.string() })), // 话题
        cntWord: z.number(),
        subTitles: z.array(z.string()), // 多标题
        timer: z.number().optional(),
    }),
});

export type ToutiaoPublishParams = z.infer<typeof ToutiaoPublishParamsSchema>;

export const COVER_TYPE: Record<CoverType, number> = {
    no: 1,
    single: 2,
    multiple: 3,
};

export const getAddTypeValue = (toutiaoAd: ToutiaoPublishParams["settingInfo"]["toutiaoAd"]) =>
    toutiaoAd === "yes" ? 3 : 2;

export type PublishAction = CommonAction<ToutiaoPublishParams, string>;

export const toutiaoPublish: PublishAction = async (task, params) => {
    task.logger.info(`toutiaoPublish actionType: ${params.actionType}`);
    // Format content HTML
    params.content = formatSectionHtml(params.content);

    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return mockAction(task, params);
    }

    return executeAction(mockAction, rpaAction)(task, params);
};
